import { useQuery, useQueryClient } from "@tanstack/react-query";
import { getUseIsMaintenanceQueryOptions } from "../../../maintenance-check-point/queries/useIsMaintenanceQuery";
import { getAddressPoints } from "../api/getAddressPoints";
import { AddressPointModel } from "../models/AddressPointModel";
import { getStreetQueryKey } from "./useStreetsQuery";

export const getAddressPointsQueryKey = (streetId: string) => [
  ...getStreetQueryKey,
  "punkty-adresowe",
  streetId,
];

export const useAddressPointsQuery = (
  streetId: string,
  options: { enabled?: boolean } = {}
) => {
  const client = useQueryClient();
  return useQuery<AddressPointModel[]>(
    getAddressPointsQueryKey(streetId),
    () => {
      client.prefetchQuery(...getUseIsMaintenanceQueryOptions);
      return getAddressPoints(streetId);
    },
    {
      ...options,
    }
  );
};
